import React, { PropTypes } from 'react/addons';
import raf from 'raf';
import { canUseDOM } from 'react/lib/ExecutionEnvironment';
import debounce from 'debounce';
import { RouteHandler } from 'react-router';
import Swiper from 'components/react-swiper';
import PureComponent from 'components/PureComponent';
import ScrollDown from 'components/ScrollDown';
import Menu from 'components/Menu';
import CityMenu from 'components/CityMenu';
import CityConfirm from 'components/CityConfirm';
import Bottle from 'components/Bottle';
// import FluxComponent from 'flummox/component';
// import CodeForm from 'components/CodeForm';
import MenuButton from 'components/MenuButton';
import Logo from 'components/Logo';
import setViewport from 'components/setViewport';
import checkMobile from 'utils/checkMobile';
import cookie from 'react-cookies';

const { CSSTransitionGroup } = React.addons;

const pagesFlow = ['/', '/original', '/source', '/faq'];
const cleanPages = ['/winners', '/winners/', '/winners/:number'];
const menuHidden = ['/winners/:number'];

function last(arr) {
  return arr[arr.length - 1];
}

class App extends PureComponent {
  static contextTypes = {
    router: PropTypes.func
  };

  static childContextTypes = {
    deviceType: PropTypes.string.isRequired
  };

  constructor() {
    super();
    this.state = {};
    this.navigate = debounce(this.navigate, 500, true);
  }

  getChildContext() {
    return {
      deviceType: this.props.deviceType
    };
  }

  componentWillMount() {
    const { deviceType } = this.props;
    const { backgrounds } = this.props;
    const currentPath = this.context.router.getCurrentPath();
    const currentRoute = last(this.context.router.getCurrentRoutes());
    const currentPathIdx = pagesFlow.indexOf(currentPath);
    const is404 = currentRoute.path === '/*';

    this.setState({
      backgroundImage: is404
        ? last(backgrounds)
        : backgrounds[currentPathIdx] || backgrounds[0],
      currentPath: this.context.router.getCurrentPath(),
      transitionName: currentPathIdx === -1 ? 't-dissolve' : 't-slideup'
    });

    if (deviceType === 'desktop' && canUseDOM) {
      document.addEventListener('keyup', this.handleKeyUp.bind(this));
    }

    if (canUseDOM) {
      backgrounds.map(bg => {
        bg.map((bg, i) => {
          let img = new Image();
          img.onload = () => {
            img = undefined;
          };
          img.src = bg[i];
        });
      });
    }
  }

  componentWillReceiveProps(nextProps) {
    if (
      this.context.router.getCurrentPath() !== '/form' &&
      nextProps.formIsOpen
    ) {
      const appStateActions = this.props.flux.getActions('appState');
      appStateActions.closeForm();
    }

    const { backgrounds } = this.props;
    const prevIdx = pagesFlow.indexOf(this.state.currentPath);
    const nextIdx = pagesFlow.indexOf(this.context.router.getCurrentPath());
    if (this.state.currentPath !== this.context.router.getCurrentPath()) {
      const transitionName =
        prevIdx === -1 || nextIdx === -1
          ? 't-dissolve'
          : prevIdx < nextIdx
          ? 't-slideup'
          : 't-slidedown';
      this.setState({ transitionName });
    }

    this.setState({
      currentPath: this.context.router.getCurrentPath()
    });

    const nextRoute = last(this.context.router.getCurrentRoutes());
    const is404 = nextRoute.path === '/*';
    if (backgrounds[nextIdx]) {
      this.setState({
        backgroundImage: backgrounds[nextIdx]
      });
    } else if (is404) {
      this.setState({
        backgroundImage: last(backgrounds)
      });
    }
  }

  handleFormClose() {
    const { router } = this.context;

    if (!router.goBack()) {
      router.transitionTo('/');
    }
  }

  handleCityMenuClose() {
    const { router } = this.context;

    if (!router.goBack()) {
      router.transitionTo('/');
    }
  }

  handleKeyUp(e) {
    const { router } = this.context;
    const appStateActions = this.props.flux.getActions('appState');

    if (['INPUT', 'TEXTAREA'].indexOf(e.target.tagName) !== -1) {
      return;
    }

    // if (e.keyCode === 39 && !this.props.menuIsOpen) {
    //   raf(() => router.transitionTo('/form'));
    // } else 
    
    if (e.keyCode === 37 && !formIsOpen) {
      raf(() => appStateActions.openMenu());
    } else if (e.keyCode === 37 && formIsOpen) {
      raf(() => this.handleFormClose());
    } else if (e.keyCode === 39 && this.props.menuIsOpen) {
      raf(() => appStateActions.closeMenu());
    }

    if (e.keyCode === 38 || (e.keyCode === 32 && e.shiftKey)) {
      this.navigate(-1);
    } else if (e.keyCode === 40 || e.keyCode === 32) {
      this.navigate(1);
    }
  }

  handleScroll(e) {
    // console.log('scroll', e.detail);
    if (e.deltaY > 0) {
      raf(() => this.navigate(1));
    } else if (e.deltaY < 0) {
      raf(() => this.navigate(-1));
    }
  }

  handleSwipe({ type }) {
    const { height: documentHeight } = document.body.getBoundingClientRect();
    if (
      type.indexOf('swipeUp') === 0 &&
      window.innerHeight + window.scrollY > documentHeight - 20
    ) {
      raf(() => {
        this.navigate(1);
        window.dispatchEvent(new Event('resize'));
      });
    } else if (type.indexOf('swipeDown') === 0 && window.scrollY < 100) {
      raf(() => {
        this.navigate(-1);
        window.dispatchEvent(new Event('resize'));
      });
    }
  }

  handleScrollDownClick() {
    const { router } = this.context;
    const onLastPage =
      pagesFlow.indexOf(router.getCurrentPath()) === pagesFlow.length - 1;

    if (onLastPage) {
      router.transitionTo(pagesFlow[0]);
    } else {
      this.navigate(1);
    }
  }

  navigate(dir) {
    const { router } = this.context;
    const currentPathIdx = pagesFlow.indexOf(router.getCurrentPath());

    if (currentPathIdx === -1) {
      return;
    }

    const nextIdx =
      currentPathIdx + 1 === pagesFlow.length
        ? currentPathIdx
        : currentPathIdx + 1;
    const prevIdx =
      currentPathIdx - 1 === -1 ? currentPathIdx : currentPathIdx - 1;

    router.transitionTo(pagesFlow[dir < 0 ? prevIdx : nextIdx]);
  }

  getCity() {
    return cookie.load('city');
  }

  getLogoColor(formIsOpen, route, isMobile) {
    if (formIsOpen || (this.props.menuIsOpen && this.props.deviceType === 'mobile')) {
      return '#B8B8B8';
    } else if (route.path === '/winners/:number' && !isMobile) {
      return '#36347f';
    } else {
      return '#FFF';
    }
  }

  render() {
    require('./App.styl');

    const { viewport, deviceType } = this.props;
    const isMobile = checkMobile(deviceType, viewport);

    if (isMobile) {
      return (
        <Swiper onSwipe={this.handleSwipe.bind(this)}>
          {this.renderApp()}
        </Swiper>
      );
    } else {
      return this.renderApp();
    }
  }

  renderApp() {
    const { backgrounds, deviceType, menuIsOpen } = this.props;
    const { router } = this.context;
    const appStateActions = this.props.flux.getActions('appState');
    const name = router.getCurrentPath();
    const route = last(router.getCurrentRoutes(name));
    const is404 = route.path === '/*';
    const isCleanPage = cleanPages.includes(route.path);
    const hideMenu = menuHidden.includes(route.path);
    const currentPathIdx = pagesFlow.indexOf(name);
    const onLastPage = currentPathIdx === pagesFlow.length - 1;
    const onFirstPage = currentPathIdx === 0;
    const formIsOpen = canUseDOM
      ? this.props.formIsOpen
      : currentPathIdx === -1 && !name.startsWith('/winners') && !is404;
    const isMobile = checkMobile(deviceType, this.props.viewport);

    const cityMenuIsOpen = name === '/city';
    const city = this.getCity();
    const cityConfirmIsOpen = city ? false : true;

    const backgroundImage = (this.state.backgroundImage ||
      backgrounds[currentPathIdx])[1];

    const logoColor = this.getLogoColor(formIsOpen, route, isMobile);

    return (
      <div
        className={`App App${name.split('/').join('-')}`}
        onWheel={deviceType === 'desktop' ? this.handleScroll.bind(this) : null}
        style={
          !isMobile && deviceType === 'tablet'
            ? { height: this.props.viewport.height }
            : cityConfirmIsOpen
            ? { paddingTop: 50 }
            : {}
        }
      >
        {!isMobile ? (
          <CSSTransitionGroup transitionName={this.state.transitionName}>
            <RouteHandler
              {...this.props}
              viewport={this.props.viewport}
              backgroundImage={backgroundImage}
              key={name}
            />
          </CSSTransitionGroup>
        ) : (
          <RouteHandler
            {...this.props}
            viewport={this.props.viewport}
            backgroundImage={backgroundImage}
          />
        )}

        {isMobile && (
          <div
            className="App__bar"
            style={cityConfirmIsOpen ? { top: 50 } : {}}
          />
        )}

        {!isMobile && !isCleanPage && (
          <Bottle
            cover={backgroundImage[1]}
            index={currentPathIdx}
            left={formIsOpen ? '75%' : cityMenuIsOpen ? '25%' : '50%'}
          />
        )}

        {/* <FluxComponent flux={this.props.flux} connectToStores={['codeForm']}>
          <CodeForm
            isOpen={formIsOpen}
            onClose={() => raf(() => this.handleFormClose())}
          />
        </FluxComponent> */}

        <CityMenu
          isOpen={cityMenuIsOpen}
          onClose={() => raf(() => this.handleCityMenuClose())}
        />

        <Menu
          isOpen={this.props.menuIsOpen}
          onClose={() => raf(() => appStateActions.closeMenu())}
        />

        <CityConfirm
          isOpen={cityConfirmIsOpen}
          onClose={() => raf(() => appStateActions.closeCityConfirm())}
        />

        <div
          className="App__top-left"
          style={
            cityConfirmIsOpen && isMobile
              ? {
                  top: formIsOpen || menuIsOpen ? 30 : 70
                }
              : {}
          }
        >
          <Logo
            onClick={() => {
              router.transitionTo(pagesFlow[0]);
            }}
            color={logoColor}
          />
        </div>

        {!hideMenu ? 
          <div
            className="App__top-right"
            style={cityConfirmIsOpen && isMobile ? { top: 50 } : {}}
          >
            <MenuButton
              onClick={() => raf(() => appStateActions.openMenu())}
            />
          </div>
        : '' }

        {!formIsOpen && !isMobile && currentPathIdx !== -1 && (
          <ScrollDown
            full={onFirstPage && deviceType === 'desktop'}
            revert={onLastPage}
            onClick={this.handleScrollDownClick.bind(this)}
          />
        )}
      </div>
    );
  }
}

export default setViewport(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js